import { BRAZE_CONTENT_CARDS } from 'common/constants';

export const premiumCamPaywallCard = {
  box__h1: 'This cam is not included in your membership.',
  box__h2: 'See this cam by upgrading.',
  button1__text: 'Go Premium',
  button1__url: '/upgrade',
  name: BRAZE_CONTENT_CARDS.PREMIUM_CAM_PAYWALL,
};

export const rewindPaywallCard = {
  box__h1: 'Relive your session',
  box__h2: "Download your rides - or the waves that got away - then share 'em with your friends",
  button1__text: 'Upgrade',
  button1__url: '/upgrade',
  name: BRAZE_CONTENT_CARDS.PREMIUM_CAM_PAYWALL,
};
